"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsCounter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _CustomCheckbox = _interopRequireDefault(require("../Checkbox/CustomCheckbox"));
var _CounterPluralize = require("../CounterPluralize");
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var _excluded = ["value", "showFlexNights", "onValueChange", "minValue", "maxValue", "checked", "onCheckedChange", "isMobile"]; // Components:
var NightsCounter = exports.NightsCounter = function NightsCounter(props) {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var value = props.value,
    showFlexNights = props.showFlexNights,
    onValueChange = props.onValueChange,
    minValue = props.minValue,
    maxValue = props.maxValue,
    checked = props.checked,
    onCheckedChange = props.onCheckedChange,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, (0, _extends2["default"])({
    value: value,
    text: (0, _pluralizeUtils.pluralizeNights)(value),
    onChange: onValueChange,
    minValue: minValue,
    maxValue: maxValue,
    isMobile: isMobile
  }, otherProps)), showFlexNights && /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    isMobile: isMobile,
    checked: checked,
    onChange: onCheckedChange
  }, "\xB12 ", t('hotel.offer.night_one')));
};
var StyledCounterPluralize = (0, _styledComponents["default"])(_CounterPluralize.CounterPluralize).withConfig({
  displayName: "NightsCounter__StyledCounterPluralize",
  componentId: "sc-rtp49r-0"
})(["height:50px;display:flex;justify-content:center;align-items:center;border-radius:0;padding:0 10px;font-size:", "px !important;line-height:", "px !important;font-weight:", " !important;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 16 : 14;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 20 : 16;
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'bold' : 'normal';
});
var StyledCheckbox = (0, _styledComponents["default"])(_CustomCheckbox["default"]).withConfig({
  displayName: "NightsCounter__StyledCheckbox",
  componentId: "sc-rtp49r-1"
})(["height:50px;display:flex;justify-content:center;align-items:center;user-select:none;outline:0;box-shadow:inset 0 1px 0 #c2c5cc;font-size:", "px;line-height:", "px;input{outline:0;}"], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 16 : 14;
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 20 : 16;
});